import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/shopify-audit")({
  component: lazyRouteComponent(() => import("./-pages/admin.shopify-audit")),
  head: () => ({
    meta: [
      { title: "Shopify Live Audit · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
